import React from 'react';
import './Button.scss';

export default function Button({children, busy, disabled, className, active, ...rest})
{
    return (
        <button 
            {...rest}
            disabled={busy||disabled} 
            className={("button " + (className || '') + (busy ? ' button-busy ' : '') + (disabled ? ' button-disabled ' : '') + (active ? ' active ' : '') )} 
        >
            {
                busy ? 
                    <span className="btn-busy-spinner-container">
                        <span className="btn-busy-spinner"></span>
                    </span>
                : null
            }
            <span className="btn-content">{children}</span>
        </button>
    );
}